import { z } from 'zod';

import { EmployeeIdpStatus, EmployeeIdpType } from '@/common/graphql';

export const IdpListParser = z.object({
  companyId: z.string().nullable().catch(null),
  type: z.nativeEnum(EmployeeIdpType).nullable().catch(null),
  status: z.nativeEnum(EmployeeIdpStatus).nullable().catch(null),
  page: z.number().catch(1),
});

export type IdpListFilterType = z.infer<typeof IdpListParser>;
